import { render, staticRenderFns } from "./EstimateFixedAttachmentMaster.vue?vue&type=template&id=83b1fbde&scoped=true&"
import script from "./EstimateFixedAttachmentMaster.vue?vue&type=script&lang=js&"
export * from "./EstimateFixedAttachmentMaster.vue?vue&type=script&lang=js&"
import style0 from "./EstimateFixedAttachmentMaster.vue?vue&type=style&index=0&id=83b1fbde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b1fbde",
  null
  
)

export default component.exports